import React, { FC } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';

import { CAMPAIGN_PRODUCTS, useFeature } from '../../shared/utils/togglz';

import { CampaignProductsPage } from './CampaignProductsPage';
import { PageNotFound } from '../PageNotFound';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';

type Props = RouteComponentProps;

const CampaignProductsRouteSwitch: FC<Props> = props => {
    const campaignsEnabled = useFeature(CAMPAIGN_PRODUCTS);

    if (!campaignsEnabled) {
        return (
            <Switch>
                <Redirect to="/catalogue" />
            </Switch>
        );
    }

    return (
        <Switch>
            <Redirect exact from={`${props.match.url}`} to={`${props.match.url}/all`} />
            <Route
                exact
                path={`${props.match.url}/:loanformat?`}
                render={() => (
                    <CheckLoanFormat>
                        <CampaignProductsPage />
                    </CheckLoanFormat>
                )}
            />
            <Route component={PageNotFound} />
        </Switch>
    );
};

export default CampaignProductsRouteSwitch;
